import axios from 'axios';

const setToken = (token) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

const dev = (process.env.REACT_APP_API_BASE_URL || 'https://localhost:5011').replace(/\/$/, '');

const baseURL = () => {
    axios.defaults.baseURL = dev;
};

export { baseURL };
export default setToken;
